import React, { useState } from 'react';
import WalletToWallet from './transfers/WalletToWallet';
import InterOperatorTransfer from './transfers/InterOperatorTransfer';
import CardToMobile from './transfers/CardToMobile';
import TransferHistory from './transfers/TransferHistory';
import FundTransferRequest from './transfers/FundTransferRequest';
import { ArrowLeftRight, Building, History, RefreshCw, Send, Lock, CreditCard } from 'lucide-react';
import { useLocalization } from '../contexts/LocalizationContext';

const Transfers: React.FC = () => {
  const { t } = useLocalization();
  const [activeTab, setActiveTab] = useState('wallet-to-wallet');

  const tabs = [
    { id: 'wallet-to-wallet', label: t('transfers.intraOperator'), icon: ArrowLeftRight, available: true },
    { id: 'inter-operator', label: t('transfers.interOperator'), icon: RefreshCw, available: true },
    { id: 'card-to-mobile', label: t('transfers.cardToMobile.tab') || 'Card to Mobile', icon: CreditCard, available: true },
    { id: 'wallet-to-bank', label: t('transfers.walletToBank'), icon: Building, available: true },
    { id: 'history', label: t('transfers.history'), icon: History, available: true },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'wallet-to-wallet':
        return <WalletToWallet />;
      case 'inter-operator':
        return <InterOperatorTransfer />;
      case 'card-to-mobile':
        return <CardToMobile />;
      case 'wallet-to-bank':
        return <FundTransferRequest direction="withdraw" />;
      case 'bank-to-wallet':
        return <FundTransferRequest direction="deposit" />;
      case 'history':
        return <TransferHistory />;
      default:
        return <WalletToWallet />;
    }
  };

  return (
    <div className="space-y-6">
      {/* Header amélioré */}
<div className="bg-gradient-to-br from-indigo-500/10 via-purple-500/10 to-blue-500/10 rounded-2xl p-6 lg:p-7 text-slate-800 shadow-lg border border-indigo-200/50 backdrop-blur-sm">
  <div className="flex items-center justify-between">
    <div className="flex items-center space-x-4">
      <div className="bg-white p-3 rounded-xl border border-indigo-100 shadow-sm">
        <Send className="h-5 w-5 lg:h-6 lg:w-6 text-indigo-600" />
      </div>
      <div>
        <h1 className="text-xl lg:text-2xl font-bold mb-1 text-slate-800">{t('transfers.title')}</h1>
        <p className="text-slate-600 text-xs lg:text-sm">
          {t('transfers.subtitle')}
        </p>
      </div>
    </div>
    <div className="hidden lg:flex items-center space-x-2 bg-emerald-50 px-3 py-1.5 rounded-full border border-emerald-200">
      <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse"></div>
      <span className="text-xs font-medium text-emerald-700">{t('common.liveSystem')}</span>
    </div>
  </div>
  
  {/* Quick Stats - Version raffinée */}
  <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 mt-5">
    <div className="bg-white rounded-lg p-3 border border-slate-200 hover:border-indigo-300 transition-all duration-200 shadow-sm">
      <p className="text-slate-500 text-xs font-medium">{t('transfers.availableTypes')}</p>
      <p className="text-slate-900 font-semibold text-base">3</p>
    </div>
    {/* <div className="bg-white rounded-lg p-3 border border-slate-200 hover:border-indigo-300 transition-all duration-200 shadow-sm">
      <p className="text-slate-500 text-xs font-medium">Security</p>
      <p className="text-slate-900 font-semibold text-base">PIN Protected</p>
    </div> */}
    <div className="bg-white rounded-lg p-3 border border-slate-200 hover:border-indigo-300 transition-all duration-200 shadow-sm">
      <p className="text-slate-500 text-xs font-medium">{t('transfers.realtime')}</p>
      <p className="text-slate-900 font-semibold text-base">{t('transfers.liveTracking')}</p>
    </div>
    <div className="bg-white rounded-lg p-3 border border-slate-200 hover:border-indigo-300 transition-all duration-200 shadow-sm">
      <p className="text-slate-500 text-xs font-medium">{t('transfers.bankTransfers')}</p>
      <p className="text-slate-900 font-semibold text-base">{t('common.comingSoon')}</p>
    </div>
  </div>
</div>

      {/* Tabs */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100">
        <div className="flex overflow-x-auto border-b border-gray-200">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex-1 flex items-center justify-center px-4 lg:px-6 py-4 text-xs lg:text-sm font-medium transition-all duration-200 whitespace-nowrap relative ${
                  activeTab === tab.id
                    ? 'text-[#000065] border-b-2 border-[#63d400] bg-green-50 font-semibold'
                    : tab.available
                    ? 'text-gray-600 hover:text-[#000065] hover:bg-gray-50'
                    : 'text-gray-400 cursor-not-allowed bg-gray-50'
                }`}
              >
                <Icon className="h-3 w-3 lg:h-4 lg:w-4 mr-1 lg:mr-2" />
                {tab.label}
                {!tab.available && (
                  <Lock className="h-3 w-3 ml-1 text-gray-400" />
                )}
              </button>
            );
          })}
        </div>

        <div className="p-4 lg:p-6">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default Transfers;